<template>
  <b-card
    class="p-1 container"
    :style="guide_css"
  >
    <b-button
      class="mb-1"
      variant="primary"
      @click="$router.go(-1)"
    >
      Go Back
    </b-button>
    <iframe
      :src="file_source"
      width="100%"
      frameborder="0"
      :style="`display:block; width:100%;${guide_css}`"
      class=""
    />
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      file_source: null,
      guide_css: '',
    }
  },
  async created() {
    const { account_type } = this.$store.state.auth.ActiveUser
    if (account_type === this.$AccountTypes.EMPLOYER || account_type === this.$AccountTypes.AGENCY) {
      const fileURL = await this.$generatePresignedUrl('media/employers_guide.pdf')
      this.file_source = fileURL
      this.guide_css = 'height: 300cm;'
    } else {
      const fileURL = await this.$generatePresignedUrl('media/applicants_guide.pdf')
      this.file_source = fileURL
      this.guide_css = 'height: 210cm;'
    }
  },
  methods: {},
}
</script>

<style>
.full-screen {
  height: 100vh;
}
</style>
